const pokemonSetMeta = {
  "30C": {
    set_name: "30th Celebration",
    slug: "30th-celebration",
    total: 128,
    pad: 3,
    year: 2026,
    promo: false,
    imageFile: "30th Celebration.jpg",
    aliases: ["30C", "30th Celebration", "30th-celebration"],
  },
  PITCH_BLACK: {
    code: null,
    set_name: "Pitch Black",
    display_name: "Pokémon TCG: Pitch Black",
    slug: "pitch-black",
    year: 2026,
    promo: false,
    imageFile: "pitchblack.jpg",
    aliases: ["Pitch Black", "Pokémon TCG: Pitch Black", "Pokemon TCG: Pitch Black", "pitch-black", "pitch black"],
  },
  CRI: {
    set_name: "Chaos Rising",
    slug: "chaos-rising",
    total: 86,
    pad: 3,
    year: 2026,
    promo: false,
    imageFile: "chaos etb.jpg",
    aliases: ["Chaos Rising", "Mega Evolution Chaos Rising", "Mega Evolution—Chaos Rising"],
  },
  POR: { set_name: "Perfect Order", total: 88, pad: 3, year: 2026, promo: false },
  ASC: { set_name: "Ascended Heroes", total: 217, pad: 3, year: 2026, promo: false },
  PFL: { set_name: "Phantasmal Flames", total: 94, pad: 3, year: 2026, promo: false },
  MEG: { set_name: "Mega Evolution", total: 132, pad: 3, year: 2026, promo: false },
  MEE: { set_name: "Mega Evolution Energy", total: 20, pad: 3, year: 2026, promo: false, notes: "Energy subset" },
  MEP: { set_name: "Mega Promos", total: null, pad: 3, year: 2026, promo: true },

  BLK: { set_name: "Black Bolt", total: 86, pad: 3, year: 2025, promo: false },
  WHT: { set_name: "White Flare", total: 86, pad: 3, year: 2025, promo: false },
  DRI: { set_name: "Destined Rivals", total: 182, pad: 3, year: 2025, promo: false },
  JTG: { set_name: "Journey Together", total: 159, pad: 3, year: 2025, promo: false },
  PRE: { set_name: "Prismatic Evolutions", total: 131, pad: 3, year: 2025, promo: false },
  SSP: { set_name: "Surging Sparks", total: 191, pad: 3, year: 2024, promo: false },
  SCR: { set_name: "Stellar Crown", total: 142, pad: 3, year: 2024, promo: false },
  SFA: { set_name: "Shrouded Fable", total: 64, pad: 3, year: 2024, promo: false },
  TWM: { set_name: "Twilight Masquerade", total: 167, pad: 3, year: 2024, promo: false },
  TEF: { set_name: "Temporal Forces", total: 162, pad: 3, year: 2024, promo: false },
  PAF: { set_name: "Paldean Fates", total: 91, pad: 3, year: 2024, promo: false },
  PAR: { set_name: "Paradox Rift", total: 182, pad: 3, year: 2023, promo: false },
  MEW: { set_name: "Pokemon 151", total: 165, pad: 3, year: 2023, promo: false },
  OBF: { set_name: "Obsidian Flames", total: 197, pad: 3, year: 2023, promo: false },
  PAL: { set_name: "Paldea Evolved", total: 193, pad: 3, year: 2023, promo: false },
  SVI: { set_name: "Scarlet & Violet", total: 198, pad: 3, year: 2023, promo: false },
  SVE: { set_name: "Scarlet & Violet Energy", total: 8, pad: 3, year: 2023, promo: false, notes: "Energy subset" },
  SVP: { set_name: "Scarlet & Violet Promos", total: null, pad: 3, year: 2023, promo: true, notes: "Promo numbering varies; keep raw number" },

  CRZ: { set_name: "Crown Zenith", total: 159, pad: 3, year: 2023, promo: false },
  SIT: { set_name: "Silver Tempest", total: 195, pad: 3, year: 2022, promo: false },
  LOR: { set_name: "Lost Origin", total: 196, pad: 3, year: 2022, promo: false },
  PGO: { set_name: "Pokemon GO", total: 78, pad: 3, year: 2022, promo: false },
  ASR: { set_name: "Astral Radiance", total: 189, pad: 3, year: 2022, promo: false },
  BRS: { set_name: "Brilliant Stars", total: 172, pad: 3, year: 2022, promo: false },
  FST: { set_name: "Fusion Strike", total: 264, pad: 3, year: 2021, promo: false },
  CEL: { set_name: "Celebrations", total: 25, pad: 3, year: 2021, promo: false },
  EVS: { set_name: "Evolving Skies", total: 203, pad: 3, year: 2021, promo: false },
  CRE: { set_name: "Chilling Reign", total: 198, pad: 3, year: 2021, promo: false },
  BST: { set_name: "Battle Styles", total: 163, pad: 3, year: 2021, promo: false },
  SHF: { set_name: "Shining Fates", total: 73, pad: 3, year: 2021, promo: false },
  VIV: { set_name: "Vivid Voltage", total: 185, pad: 3, year: 2020, promo: false },
  CPA: { set_name: "Champion's Path", total: 73, pad: 3, year: 2020, promo: false },
  DAA: { set_name: "Darkness Ablaze", total: 189, pad: 3, year: 2020, promo: false },
  RCL: { set_name: "Rebel Clash", total: 192, pad: 3, year: 2020, promo: false },
  SSH: { set_name: "Sword & Shield", total: 202, pad: 3, year: 2020, promo: false },
  SWSHP: { set_name: "Sword & Shield Promos", total: null, pad: 3, year: 2020, promo: true, notes: "Promo numbering varies; keep raw number" },
  SP: { set_name: "Sword & Shield Promos", total: null, pad: 3, year: 2020, promo: true, notes: "Legacy short code alias" },

  CEC: { set_name: "Cosmic Eclipse", total: 236, pad: 3, year: 2019, promo: false },
  HIF: { set_name: "Hidden Fates", total: 68, pad: 3, year: 2019, promo: false },
  UNM: { set_name: "Unified Minds", total: 236, pad: 3, year: 2019, promo: false },
  UNB: { set_name: "Unbroken Bonds", total: 214, pad: 3, year: 2019, promo: false },
  DET: { set_name: "Detective Pikachu", total: 18, pad: 3, year: 2019, promo: false },
  TEU: { set_name: "Team Up", total: 181, pad: 3, year: 2019, promo: false },
  LOT: { set_name: "Lost Thunder", total: 214, pad: 3, year: 2018, promo: false },
  DRM: { set_name: "Dragon Majesty", total: 70, pad: 3, year: 2018, promo: false },
  CES: { set_name: "Celestial Storm", total: 168, pad: 3, year: 2018, promo: false },
  FLI: { set_name: "Forbidden Light", total: 131, pad: 3, year: 2018, promo: false },
  UPR: { set_name: "Ultra Prism", total: 156, pad: 3, year: 2018, promo: false },
  CIN: { set_name: "Crimson Invasion", total: 111, pad: 3, year: 2017, promo: false },
  SLG: { set_name: "Shining Legends", total: 73, pad: 3, year: 2017, promo: false },
  BUS: { set_name: "Burning Shadows", total: 147, pad: 3, year: 2017, promo: false },
  GRI: { set_name: "Guardians Rising", total: 145, pad: 3, year: 2017, promo: false },
  SUM: { set_name: "Sun & Moon", total: 149, pad: 3, year: 2017, promo: false },
  SMP: { set_name: "Sun & Moon Promos", total: null, pad: 3, year: 2017, promo: true, notes: "Promo numbering varies; keep raw number" },

  EVO: { set_name: "Evolutions", total: 108, pad: 3, year: 2016, promo: false },
  STS: { set_name: "Steam Siege", total: 114, pad: 3, year: 2016, promo: false },
  FCO: { set_name: "Fates Collide", total: 124, pad: 3, year: 2016, promo: false },
  GEN: { set_name: "Generations", total: 83, pad: 3, year: 2016, promo: false },
  BKP: { set_name: "BREAKpoint", total: 122, pad: 3, year: 2016, promo: false },
  BKT: { set_name: "BREAKthrough", total: 162, pad: 3, year: 2015, promo: false },
  AOR: { set_name: "Ancient Origins", total: 98, pad: 3, year: 2015, promo: false },
  ROS: { set_name: "Roaring Skies", total: 108, pad: 3, year: 2015, promo: false },
  DCR: { set_name: "Double Crisis", total: 34, pad: 3, year: 2015, promo: false },
  PRC: { set_name: "Primal Clash", total: 160, pad: 3, year: 2015, promo: false },
  PHF: { set_name: "Phantom Forces", total: 119, pad: 3, year: 2014, promo: false },
  FFI: { set_name: "Furious Fists", total: 111, pad: 3, year: 2014, promo: false },
  FLF: { set_name: "Flashfire", total: 106, pad: 3, year: 2014, promo: false },
  XY: { set_name: "XY", total: 146, pad: 3, year: 2014, promo: false },
  KSS: { set_name: "Kalos Starter Set", total: 39, pad: 3, year: 2014, promo: false },
  XYP: { set_name: "XY Promos", total: null, pad: 3, year: 2014, promo: true, notes: "Promo numbering varies; keep raw number" },

  LTR: { set_name: "Legendary Treasures", total: 113, pad: 3, year: 2013, promo: false },
  PLB: { set_name: "Plasma Blast", total: 101, pad: 3, year: 2013, promo: false },
  PLF: { set_name: "Plasma Freeze", total: 116, pad: 3, year: 2013, promo: false },
  PLS: { set_name: "Plasma Storm", total: 135, pad: 3, year: 2013, promo: false },
  BCR: { set_name: "Boundaries Crossed", total: 149, pad: 3, year: 2012, promo: false },
  DRV: { set_name: "Dragon Vault", total: 21, pad: 3, year: 2012, promo: false },
  DRX: { set_name: "Dragons Exalted", total: 124, pad: 3, year: 2012, promo: false },
  DEX: { set_name: "Dark Explorers", total: 108, pad: 3, year: 2012, promo: false },
  NXD: { set_name: "Next Destinies", total: 99, pad: 3, year: 2012, promo: false },
  NVI: { set_name: "Noble Victories", total: 101, pad: 3, year: 2011, promo: false },
  EPO: { set_name: "Emerging Powers", total: 98, pad: 3, year: 2011, promo: false },
  BLW: { set_name: "Black & White", total: 114, pad: 3, year: 2011, promo: false },
  BWP: { set_name: "Black & White Promos", total: null, pad: 3, year: 2011, promo: true, notes: "Promo numbering varies; keep raw number" },

  CL: { set_name: "Call of Legends", total: 95, pad: 0, year: 2011, promo: false },
  TM: { set_name: "Triumphant", total: 102, pad: 0, year: 2010, promo: false },
  UD: { set_name: "Undaunted", total: 90, pad: 0, year: 2010, promo: false },
  UL: { set_name: "Unleashed", total: 95, pad: 0, year: 2010, promo: false },
  HS: { set_name: "HeartGold & SoulSilver", total: 123, pad: 0, year: 2010, promo: false },
  HSP: { set_name: "HeartGold & SoulSilver Promos", total: null, pad: 0, year: 2010, promo: true, notes: "Promo numbering varies; keep raw number" },

  AR: { set_name: "Arceus", total: 99, pad: 0, year: 2009, promo: false },
  SV: { set_name: "Supreme Victors", total: 147, pad: 0, year: 2009, promo: false },
  RR: { set_name: "Rising Rivals", total: 111, pad: 0, year: 2009, promo: false },
  P9: { set_name: "POP Series 9", total: 17, pad: 0, year: 2009, promo: false },
  PL: { set_name: "Platinum", total: 127, pad: 0, year: 2009, promo: false },
  LA: { set_name: "Legends Awakened", total: 146, pad: 0, year: 2008, promo: false },
  ST: { set_name: "Stormfront", total: 100, pad: 0, year: 2008, promo: false },
  SF: { set_name: "Secret Wonders", total: 132, pad: 0, year: 2007, promo: false },
  DP: { set_name: "Diamond & Pearl", total: 130, pad: 0, year: 2007, promo: false },
  DPP: { set_name: "Diamond & Pearl Promos", total: null, pad: 0, year: 2007, promo: true, notes: "Promo numbering varies; keep raw number" },

  PK: { set_name: "Power Keepers", total: 108, pad: 0, year: 2007, promo: false },
  DF: { set_name: "Dragon Frontiers", total: 101, pad: 0, year: 2006, promo: false },
  CG: { set_name: "Crystal Guardians", total: 100, pad: 0, year: 2006, promo: false },
  P4: { set_name: "POP Series 4", total: 17, pad: 0, year: 2006, promo: false },
  HP: { set_name: "Holon Phantoms", total: 111, pad: 0, year: 2006, promo: false },
  P3: { set_name: "POP Series 3", total: 17, pad: 0, year: 2006, promo: false },
  LM: { set_name: "Legend Maker", total: 93, pad: 0, year: 2006, promo: false },
  DS: { set_name: "Delta Species", total: 113, pad: 0, year: 2005, promo: false },
  UF: { set_name: "Unseen Forces", total: 115, pad: 0, year: 2005, promo: false },
  P2: { set_name: "POP Series 2", total: 17, pad: 0, year: 2005, promo: false },
  EM: { set_name: "Emerald", total: 106, pad: 0, year: 2005, promo: false },
  DX: { set_name: "Deoxys", total: 107, pad: 0, year: 2005, promo: false },
  TRR: { set_name: "Team Rocket Returns", total: 109, pad: 0, year: 2004, promo: false },
  P1: { set_name: "POP Series 1", total: 17, pad: 0, year: 2004, promo: false },
  RG: { set_name: "FireRed & LeafGreen", total: 112, pad: 0, year: 2004, promo: false, imageFile: "FireRed & LeafGreen.jpg" },
  HL: { set_name: "Hidden Legends", total: 102, pad: 0, year: 2004, promo: false },
  MA: { set_name: "Team Magma vs Team Aqua", total: 95, pad: 0, year: 2004, promo: false },
  DR: { set_name: "Dragon", total: 97, pad: 0, year: 2003, promo: false },
  SS: { set_name: "Sandstorm", total: 100, pad: 0, year: 2003, promo: false },
  RS: { set_name: "Ruby & Sapphire", total: 109, pad: 0, year: 2003, promo: false },
  NP: { set_name: "Nintendo Promos", total: null, pad: 0, year: 2004, promo: true, notes: "Promo numbering varies; keep raw number" },

  SK: { set_name: "Skyridge", total: 144, pad: 0, year: 2003, promo: false },
  AQ: { set_name: "Aquapolis", total: 147, pad: 0, year: 2003, promo: false },
  BG: { set_name: "Best of Game", total: 9, pad: 0, year: 2003, promo: false },
  EXP: { set_name: "Expedition", total: 165, pad: 0, year: 2002, promo: false },
  LC: { set_name: "Legendary Collection", total: 110, pad: 0, year: 2002, promo: false },
  N4: { set_name: "Neo Destiny", total: 105, pad: 0, year: 2002, promo: false },
  N3: { set_name: "Neo Revelation", total: 64, pad: 0, year: 2001, promo: false },
  SI: { set_name: "Southern Islands", total: 18, pad: 0, year: 2001, promo: false },
  N2: { set_name: "Neo Discovery", total: 75, pad: 0, year: 2001, promo: false },
  N1: { set_name: "Neo Genesis", total: 111, pad: 0, year: 2000, promo: false },
  G2: { set_name: "Gym Challenge", total: 132, pad: 0, year: 2000, promo: false },
  G1: { set_name: "Gym Heroes", total: 132, pad: 0, year: 2000, promo: false },
  TR: { set_name: "Team Rocket", total: 82, pad: 0, year: 2000, promo: false },
  BS2: { set_name: "Base Set 2", total: 130, pad: 0, year: 2000, promo: false },
  FSL: { set_name: "Fossil", total: 62, pad: 0, year: 1999, promo: false },
  FO:  { set_name: "Fossil", total: 62, pad: 0, year: 1999, promo: false },
  JGL: { set_name: "Jungle", total: 64, pad: 0, year: 1999, promo: false },
  JU:  { set_name: "Jungle", total: 64, pad: 0, year: 1999, promo: false },
  BS: { set_name: "Base Set", total: 102, pad: 0, year: 1999, promo: false },
};

export default pokemonSetMeta;

